import { render, staticRenderFns } from "./MiniviewAnswerGroups.vue?vue&type=template&id=68872ada"
import script from "./MiniviewAnswerGroups.vue?vue&type=script&lang=js"
export * from "./MiniviewAnswerGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports